/** @format */

import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu, Modal } from "antd";
import React, { useState } from "react";
import { Collegamento } from "./Collegamento";
import { THome } from "../../../../redux-modules/declarations/maps/home";
import { TJustificative } from "../../../../redux-modules/declarations/maps/justificatives";
import { Routes } from "../../../../utils/Routes";
import { NewRequestForm } from "../../../layout/Widgets/CreateRequest/partials/NewRequestForm";
import { periodoRichiesta, pillolaStatoRichiesta } from "../format";

interface Props {
  richieste: THome["richieste"];
  oggi: string;
  tipi: TJustificative[];
}

/**
 * Richieste di chi è collegato (in attesa e non ancora finite) e nuova richiesta. Il modulo è quello
 * della Home precedente (stessi campi aggiuntivi, stessa POST /requests); si chiude a richiesta creata.
 */
export const Richieste = ({ richieste, oggi, tipi }: Props): JSX.Element => {
  const [tipoNuova, setTipoNuova] = useState<string | undefined>();

  const menu = (
    <Menu
      onClick={({ key }): void => setTipoNuova(String(key))}
      items={tipi.map(t => ({
        key: t.id,
        label: (
          <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            <i
              aria-hidden="true"
              style={{
                display: "inline-block",
                width: 10,
                height: 10,
                borderRadius: 3,
                background: t.color,
              }}
            />
            {t.name}
          </span>
        ),
      }))}
    />
  );

  return (
    <section className="scheda" aria-labelledby="titolo-richieste">
      <div className="testa">
        <div className="accanto">
          <h2 id="titolo-richieste">Le mie richieste</h2>
          {richieste.in_attesa > 0 && (
            <span className="pillola attesa">{richieste.in_attesa} in attesa</span>
          )}
        </div>
        <Dropdown overlay={menu} trigger={["click"]} disabled={!tipi.length}>
          <Button icon={<PlusOutlined />}>
            Nuova <DownOutlined />
          </Button>
        </Dropdown>
      </div>

      {richieste.elenco.length ? (
        <ul className="elenco">
          {richieste.elenco.map(r => {
            const stato = pillolaStatoRichiesta(r);
            return (
              <li key={r.id}>
                <span
                  className="colore"
                  style={{ background: r.colore || "#B3B8C6" }}
                  aria-hidden="true"
                />
                <span className="testo">
                  <span className="titolo">{r.tipo}</span>
                  <span className="sotto numeri">{periodoRichiesta(r, oggi)}</span>
                </span>
                <span className={`pillola ${stato.classe}`}>{stato.testo}</span>
              </li>
            );
          })}
        </ul>
      ) : (
        <span className="vuoto">Nessuna richiesta in corso.</span>
      )}

      <Collegamento className="collegamento" to={Routes.requests}>
        Calendario delle richieste
      </Collegamento>

      <Modal
        visible={!!tipoNuova}
        footer={null}
        onCancel={(): void => setTipoNuova(undefined)}
        destroyOnClose
        width={760}
      >
        {tipoNuova && <NewRequestForm creatingType={tipoNuova} onClose={setTipoNuova} />}
      </Modal>
    </section>
  );
};
